import React from 'react'
import Portal from '../../../Portal/Portal'
import closeIcon from '../../../../images/common/close.png'

type Props = {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

export const ModalShell = ({ isOpen, onClose, children }: Props) => {
  if (!isOpen) return null
  return (
    <Portal isInBody={false}>
      <div className='product-order-popup-container'>
        <div className='product-order-popup-body-container'>
          <img
            role='presentation'
            className='product-order-popup-close-icon'
            src={closeIcon}
            alt='Close'
            onClick={onClose}
          />
          {children}
        </div>
      </div>
    </Portal>
  )
}
